import React, { useState, useMemo } from 'react';

import { observer, inject } from 'mobx-react';
import { mergeStyleSets } from '@fluentui/react';

import LockedFeature from 'src/components/base/LockedFeature';

import FlowstepList from 'src/components/Flows/FlowstepList';
import FlowList from 'src/components/Flows/FlowList';
import { useHistory } from 'react-router-dom';

const classNames = mergeStyleSets({
  flowsList: {
    width: '100%',
    height: '40vh',
    overflow: 'auto',
  },
});

const FlowsComponent = ({ officeStore, userStore, selectedId, dataStore }) => {
  const [anyEditModeEnabled, setAnyEditModeEnabled] = useState(false);
  const {selectedFlowId} = dataStore;

  const activeWorksheetId = useMemo(() => officeStore.activeWorksheetId, [officeStore.activeWorksheetId]);

  const flows = useMemo(() => (
    officeStore.flows.map(flow => ({
      flow,
      flowsteps: flow.options.flowsteps.map(({ id }) => {
        const flowstep = officeStore.flowSteps.find(x => x.id === id);
        return {
          flowstep,
          worksheet: officeStore.worksheets.find(x => x.id === flowstep?.worksheetId),
        }
      }).filter(({ flowstep }) => flowstep),
    }))
  ), [officeStore.flows, officeStore.flowSteps, officeStore.worksheets]);

  const selectedFlow = useMemo(
    () => flows.find(x => x.flow.id === selectedFlowId), [selectedFlowId, flows]
  );

  if (!userStore.license.flows.seeTabContent.can) {
    return <LockedFeature plans={userStore.license.flows.seeTabContent.plans} />;
  }

  const handleAnyEditModeEnabled = () => setAnyEditModeEnabled(!anyEditModeEnabled);

  const handleOnlyOnActiveWorksheet = () => dataStore.setOnlyOnActiveWorksheet(!dataStore.onlyOnActiveWorksheet);

  const handleSelectFlow = flowData => {
    const newId = flowData?.flow.id;
    if (newId !== selectedFlowId) {
      dataStore.selectedFlowId = newId;
    }
  };

  const flowListProps = {
    allFlows: flows,
    selectedFlow,
    onSelectFlow: handleSelectFlow,
    anyEditModeEnabled,
    onEditModeEnabled: handleAnyEditModeEnabled,
    onlyOnActiveWorksheet: dataStore.onlyOnActiveWorksheet,
    onOnlyOnActiveWorksheet: handleOnlyOnActiveWorksheet,
    activeWorksheetId,
    license: userStore.license,
  };

  const flowstepListProps = {
    ...flowListProps,
    selectedFlow,
  };

  return (
    <div className={classNames.root}>
      <FlowList {...flowListProps} />
      <FlowstepList {...flowstepListProps} />
    </div>
  );
};

const Flows = inject('officeStore', 'userStore', 'dataStore')(observer(FlowsComponent));
export default Flows;
